<script context="module">
    import { defaultTableRowBgColor } from "../../../Utils/utilConstants.svelte";

    export const getDisplayColumn = (cols, tableRef, config) => {
        if (!Array.isArray(cols) || !tableRef) return [];

        let totalLeftWidth = 0;
        let totalRightWidth = 0;

        if (config.showStickyLeftBlur) {
            const transparentColumn = {
                key: "invisibleTransparentColumn",
                title: "",
                class: "px-[5px]",
                headerClass: "w-[10px]",
                csvExportHidden: true,
                value: (v) => "",
                stickyLeft: true,
            };

            cols = [...cols, transparentColumn];
        }

        // Sort columns so that stickyLeft comes first
        cols.sort((a, b) => {
            if (a.stickyLeft && !b.stickyLeft) return -1;
            if (!a.stickyLeft && b.stickyLeft) return 1;
            return 0;
        });

        const totalStickyLeftCols = cols.filter((col) => col.stickyLeft).length;

        const rows = tableRef.getElementsByTagName("tr");
        if (!rows?.length) return [];

        const headerRow = rows[0];
        const headerCells = headerRow.getElementsByTagName("th");
        const bodyRows = Array.from(rows).slice(1);

        const defaultStickyRowClass = `sticky ${defaultTableRowBgColor}`;

        setTimeout(() => {
            cols = cols.map((col, index) => {
                const { stickyLeft, stickyRight } = col;

                if (stickyLeft) {
                    const headerCell = headerCells[index];
                    const computedStyle = window.getComputedStyle(headerCell);
                    const cellWidth = computedStyle.width
                        ? parseFloat(computedStyle.width)
                        : 0;

                    if (headerCell) {
                        headerCell.style.left = `${totalLeftWidth}px`;
                        headerCell.classList.add(
                            ...defaultStickyRowClass.split(" "),
                        );
                    }

                    bodyRows.forEach((row, rIndex) => {
                        const cell = row.getElementsByTagName("td")[index];
                        if (cell) {
                            cell.style.left = `${totalLeftWidth}px`;

                            const bgColorClass =
                                typeof config.bgColor === "function"
                                    ? config.bgColor(row)
                                    : config.bgColor;

                            cell.classList.add(
                                ...defaultStickyRowClass.split(" "),
                                "z-[5]",
                                "hover:z-[10]",
                                bgColorClass,
                            );

                            if (index === totalStickyLeftCols - 1) {
                                cell.style.backgroundImage =
                                    "linear-gradient(to left, transparent, rgba(0, 0, 0, 0.1))";
                                cell.style.backgroundSize = "10px 100%";
                                cell.style.backgroundPosition = "right center";
                                cell.style.backgroundRepeat = "no-repeat";

                                if (config.showStickyLeftBlur)
                                    cell.style.mixBlendMode = "multiply";
                            }
                        }
                    });

                    totalLeftWidth += cellWidth;
                }

                if (stickyRight) {
                    const headerCell = headerCells[index];
                    if (headerCell) {
                        headerCell.classList.add(
                            "sticky",
                            "right-0",
                            defaultTableRowBgColor,
                        );
                    }

                    bodyRows.forEach((row) => {
                        const cell = row.getElementsByTagName("td")[index];
                        if (cell) {
                            const bgColorClass =
                                typeof config.bgColor === "function"
                                    ? config.bgColor(row)
                                    : config.bgColor;

                            cell.classList.add(
                                "sticky",
                                "right-0",
                                "z-10",
                                bgColorClass,
                            );
                        }
                    });
                }

                return col;
            });
        }, 0);

        return cols;
    };

    export const updateStickyColumns = (tds) => {
        tds.forEach((node, index) => {});
    };
</script>
